import {
    getField,
    updateField
} from "vuex-map-fields"
import {requestSubmit} from "../../api"
import {
    ADD_ROW, RESET_FORM
} from "../../constant-types"
import { defaultRemoveRowMutation, defaultSetFormsMutation } from "../../default-method"

const getDefaultState = () => {
    return {
        rows: [getDefaultRowState()],
        payment_total : 0,
        payment_total_after_qty_return : 0,
        has_return: false,
        sale_id: '',
        status_credit_payment: false, // default is direct cash
        default_to_user_cash_id : null,
        default_from : '---'
    }
}

const getDefaultRowState = (state, paymentType = 'cash') => {
    let currentDateTime = (new Date()).toISOString()
    let status_paid;
    let due_date = currentDateTime;
    let paid_date_time;
    let nominal = 0;
    let absolute_idx = 0;
    if (paymentType === 'cash') {
        status_paid = true
        paid_date_time = currentDateTime
    } else {
        status_paid = false
        paid_date_time = null
    }

    if (state) {
        absolute_idx = state.rows.reduce((prev, cur) => {
            return (Math.max(prev.absolute_idx ? prev.absolute_idx : 0, cur.absolute_idx)) + 1
        }, 0)
        // nominal base on payment total if has return or not
        nominal = ( state.has_return ? state.payment_total_after_qty_return : state.payment_total )- state.rows.reduce((prev, cur) => prev + cur.nominal, 0) // add remain
    }

    return {
        absolute_idx,
        id: '',
        due_date,
        due_date_code: '',
        paid_date_time,
        from: state ? state.default_from : '---',
        to_user_cash_id: state ? state.default_to_user_cash_id : null,
        nominal,
        status_paid,
        memo: '',
        created_by_id: ''
    }
}

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state, payload) {
            let paymentType = payload === undefined ? 'credit' : payload.paymentType
            state.rows.push(getDefaultRowState(state, paymentType))
        },
        ...defaultRemoveRowMutation,
        // use for sale form on PaymentProcess
        REMOVE_ROW_ABSOLUTE(state, absoluteIdx) {
            let idx = state.rows.findIndex(r => r.absolute_idx === absoluteIdx)
            state.rows.splice(idx, 1)
        },
        [RESET_FORM](state) {
            state.rows = [getDefaultRowState(state)]
            state.payment_total = 0
            state.sale_id = ''
            state.status_credit_payment = false
        },
        UPDATE_REFERENCE(state, { payment_total, sale_id, status_credit_payment }) {
            state.payment_total = payment_total
            state.sale_id = sale_id
            state.status_credit_payment = status_credit_payment
            // update latest for remain (  when rows only 1, should update pre payment same as payment total )
            let latestIndex = state.rows.length - 1
            let currentTotal = state.rows.reduce((prev, cur, curIdx) => {
                if (latestIndex > curIdx) {
                    return prev + cur.nominal
                } else {
                    return prev
                }
            }, 0)
            if ( latestIndex === 0 ) {
                state.rows[0].nominal = payment_total
            } else {
                state.rows[latestIndex].nominal = payment_total - currentTotal
            }
        },
        ...defaultSetFormsMutation,
        updateField

    },
    // can async
    actions: {
        requestUpdate({commit, state}) {
            return requestSubmit(`sale/${state.sale_id}/payments`, { 
                payments : state.rows,
                payment_total : state.payment_total,
                payment_total_after_qty_return : state.payment_total_after_qty_return,
                has_return : state.has_return,
                status_credit_payment: state.status_credit_payment
            }, commit)
        },
        updateReference({commit, state, rootState}, { payment_total, sale_id, status_credit_payment }) {
            commit('UPDATE_REFERENCE', { payment_total, sale_id, status_credit_payment })
            // when payment row only once, indicate it's customer_cash
            if (state.rows.length === 1) {
                commit('sale/updateField', { path: 'form.customer_cash_total', value: payment_total }, { root : true })
            }
        }
    },
    // call variable with custom display
    getters: {
        getField,
        formReady: state => {
            let sumNominal = _.sumBy(state.rows, 'nominal')
            // user cash id should fill, when has nominal
            if ( state.rows.some(sp => !sp.to_user_cash_id) ) return false
            if ( state.status_credit_payment ) {
                // when is credit, nominal should not negative but allow zero for direct cash
                if ( state.rows.some(sp => sp.nominal < 0 ) ) return false
                if ( state.rows.some(sp => sp.nominal === 0 && !sp.status_paid ) ) return false
            } else {
                // when is cash, nominal should not negative or zero
                if ( state.rows.some(sp => sp.nominal <= 0 ) ) return false
            }
            // sum of nominal should not zero or negative
            if (sumNominal <= 0) return false

            // paymentTotalIsNotExceed
            if (state.has_return) {
                return sumNominal === state.payment_total_after_qty_return
            } else {
                return sumNominal === state.payment_total
            }
        }
    }
})

